
import { useEffect, useMemo, useRef, useState, useCallback } from "react";
import {
  CalendarBlank,
  SpinnerGap,
  X,
  TrendUp,
  ArrowUpRight,
  ArrowDownRight,
  Wallet,
  Users,
  GlobeHemisphereWest,
  ChartBar,
  Tag,
  ArrowClockwise
} from "phosphor-react";
import { countryOptions } from "../../utils/data/CountryDialCodes"

import statistiquesService from "../../services/statistiquesService";
import { DateRangePicker } from "../../components";

import {
  ResponsiveContainer,
  AreaChart,
  Area,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
} from "recharts";

import * as echarts from "echarts";

/* =========================
 * Platform colors
 * ========================= */
const PLATFORM_COLORS = {
  meta: "#2F80ED",
  google: "#34A853",
  tiktok: "#111827",
  snapchat: "#FACC15",
  other: "#9CA3AF",
};
const TikTokIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="35" viewBox="0 0 48 48">
    <path fill="#212121" fillRule="evenodd" d="M10.904,6h26.191C39.804,6,42,8.196,42,10.904v26.191 C42,39.804,39.804,42,37.096,42H10.904C8.196,42,6,39.804,6,37.096V10.904C6,8.196,8.196,6,10.904,6z" clipRule="evenodd"></path>
    <path fill="#ec407a" fillRule="evenodd" d="M29.208,20.607c1.576,1.126,3.507,1.788,5.592,1.788v-4.011 c-0.395,0-0.788-0.041-1.174-0.123v3.157c-2.085,0-4.015-0.663-5.592-1.788v8.184c0,4.094-3.321,7.413-7.417,7.413 c-1.528,0-2.949-0.462-4.129-1.254c1.347,1.376,3.225,2.23,5.303,2.23c4.096,0,7.417-3.319,7.417-7.413L29.208,20.607L29.208,20.607 z M30.657,16.561c-0.805-0.879-1.334-2.016-1.449-3.273v-0.516h-1.113C28.375,14.369,29.331,15.734,30.657,16.561L30.657,16.561z M19.079,30.832c-0.45-0.59-0.693-1.311-0.692-2.053c0-1.873,1.519-3.391,3.393-3.391c0.349,0,0.696,0.053,1.029,0.159v-4.1 c-0.389-0.053-0.781-0.076-1.174-0.068v3.191c-0.333-0.106-0.68-0.159-1.03-0.159c-1.874,0-3.393,1.518-3.393,3.391 C17.213,29.127,17.972,30.274,19.079,30.832z" clipRule="evenodd"></path>
    <path fill="#fff" fillRule="evenodd" d="M28.034,19.63c1.576,1.126,3.507,1.788,5.592,1.788v-3.157 c-1.164-0.248-2.194-0.856-2.969-1.701c-1.326-0.827-2.281-2.191-2.561-3.788h-2.923v16.018c-0.007,1.867-1.523,3.379-3.393,3.379 c-1.102,0-2.081-0.525-2.701-1.338c-1.107-0.558-1.866-1.705-1.866-3.029c0-1.873,1.519-3.391,3.393-3.391 c0.359,0,0.705,0.056,1.03,0.159V21.38c-4.024,0.083-7.26,3.369-7.26,7.411c0,2.018,0.806,3.847,2.114,5.183 c1.18,0.792,2.601,1.254,4.129,1.254c4.096,0,7.417-3.319,7.417-7.413L28.034,19.63L28.034,19.63z" clipRule="evenodd"></path>
    <path fill="#81d4fa" fillRule="evenodd" d="M33.626,18.262v-0.854c-1.05,0.002-2.078-0.292-2.969-0.848 C31.445,17.423,32.483,18.018,33.626,18.262z M28.095,12.772c-0.027-0.153-0.047-0.306-0.061-0.461v-0.516h-4.036v16.019 c-0.006,1.867-1.523,3.379-3.393,3.379c-0.549,0-1.067-0.13-1.526-0.362c0.62,0.813,1.599,1.338,2.701,1.338 c1.87,0,3.386-1.512,3.393-3.379V12.772H28.095z M21.635,21.38v-0.909c-0.337-0.046-0.677-0.069-1.018-0.069 c-4.097,0-7.417,3.319-7.417,7.413c0,2.567,1.305,4.829,3.288,6.159c-1.308-1.336-2.114-3.165-2.114-5.183 C14.374,24.749,17.611,21.463,21.635,21.38z" clipRule="evenodd"></path>
  </svg>
)

const GoogleIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 48 48">
    <polygon fill="#ffc107" points="30.129,15.75 18.871,9.25 5.871,31.25 17.129,37.75"></polygon>
    <path fill="#1e88e5" d="M31.871,37.75c1.795,3.109,5.847,4.144,8.879,2.379c3.103-1.806,4.174-5.77,2.379-8.879l-13-22 c-1.795-3.109-5.835-4.144-8.879-2.379c-3.106,1.801-4.174,5.77-2.379,8.879L31.871,37.75z"></path>
    <circle cx="11.5" cy="34.5" r="6.5" fill="#43a047"></circle>
  </svg>
)

const MetaIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 48 48">
    <path fill="#0081fb" d="M47,29.36l-2.193,1.663L42.62,29.5c0-0.16,0-0.33-0.01-0.5c0-0.16,0-0.33-0.01-0.5 c-0.14-3.94-1.14-8.16-3.14-11.25c-1.54-2.37-3.51-3.5-5.71-3.5c-2.31,0-4.19,1.38-6.27,4.38c-0.06,0.09-0.13,0.18-0.19,0.28 c-0.04,0.05-0.07,0.1-0.11,0.16c-0.1,0.15-0.2,0.3-0.3,0.46c-0.9,1.4-1.84,3.03-2.86,4.83c-0.09,0.17-0.19,0.34-0.28,0.51 c-0.03,0.04-0.06,0.09-0.08,0.13l-0.21,0.37l-1.24,2.19c-2.91,5.15-3.65,6.33-5.1,8.26C14.56,38.71,12.38,40,9.51,40 c-3.4,0-5.56-1.47-6.89-3.69C1.53,34.51,1,32.14,1,29.44l4.97,0.17c0,1.76,0.38,3.1,0.89,3.92C7.52,34.59,8.49,35,9.5,35 c1.29,0,2.49-0.27,4.77-3.43c1.83-2.53,3.99-6.07,5.44-8.3l1.37-2.09l0.29-0.46l0.3-0.45l0.5-0.77c0.76-1.16,1.58-2.39,2.46-3.57 c0.1-0.14,0.2-0.28,0.31-0.42c0.1-0.14,0.21-0.28,0.31-0.41c0.9-1.15,1.85-2.22,2.87-3.1c1.85-1.61,3.84-2.5,5.85-2.5 c3.37,0,6.58,1.95,9.04,5.61c2.51,3.74,3.82,8.4,3.97,13.25c0.01,0.16,0.01,0.33,0.01,0.5C47,29.03,47,29.19,47,29.36z"></path>
    <linearGradient id="meta_g1" x1="42.304" x2="13.533" y1="24.75" y2="24.75" gradientUnits="userSpaceOnUse">
      <stop offset="0" stopColor="#0081fb"></stop><stop offset=".995" stopColor="#0064e1"></stop>
    </linearGradient>
    <path fill="url(#meta_g1)" d="M4.918,15.456 C7.195,11.951,10.483,9.5,14.253,9.5c2.184,0,4.354,0.645,6.621,2.493c2.479,2.02,5.122,5.346,8.419,10.828l1.182,1.967 c2.854,4.746,4.477,7.187,5.428,8.339C37.125,34.606,37.888,35,39,35c2.82,0,3.617-2.54,3.617-5.501L47,29.362 c0,3.095-0.611,5.369-1.651,7.165C44.345,38.264,42.387,40,39.093,40c-2.048,0-3.862-0.444-5.868-2.333 c-1.542-1.45-3.345-4.026-4.732-6.341l-4.126-6.879c-2.07-3.452-3.969-6.027-5.068-7.192c-1.182-1.254-2.642-2.754-5.067-2.754 c-1.963,0-3.689,1.362-5.084,3.465L4.918,15.456z"></path>
  </svg>
)

const SnapchatIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 48 48">
    <path fill="#ffeb3b" d="M24,4C12.402,4,3,13.402,3,25c0,11.598,9.402,21,21,21s21-9.402,21-21C45,13.402,35.598,4,24,4z"></path>
    <path fill="#fff" d="M24,36c-2.451,0-4.045-1.09-4.827-1.612c-0.477-0.317-0.924-0.616-1.317-0.705 c-0.345-0.078-0.685-0.118-1.012-0.118c-0.59,0-1.056,0.103-1.386,0.175c-0.207,0.045-0.385,0.084-0.526,0.084 c-0.143,0-0.298-0.032-0.367-0.267c-0.064-0.218-0.107-0.428-0.148-0.631c-0.116-0.568-0.198-0.92-0.416-0.954 c-2.562-0.401-3.295-0.945-3.464-1.331c-0.024-0.055-0.037-0.11-0.04-0.165c-0.008-0.138,0.09-0.258,0.227-0.283 c3.731-0.614,5.399-4.440,5.467-4.589c0.004-0.009,0.008-0.017,0.012-0.026c0.225-0.456,0.268-0.851,0.131-1.174 c-0.258-0.611-1.099-0.879-1.657-1.058c-0.137-0.044-0.268-0.086-0.371-0.126c-0.504-0.198-1.349-0.612-1.241-1.186 c0.078-0.416,0.615-0.707,1.049-0.707c0.12,0,0.226,0.021,0.316,0.063c0.518,0.242,0.986,0.364,1.392,0.364 c0.558,0,0.802-0.236,0.833-0.266c-0.015-0.273-0.033-0.557-0.051-0.846c-0.119-1.922-0.268-4.313,0.337-5.674 C18.915,13.058,22.304,13,23.104,13h0.792c0.8,0,4.189,0.058,6.254,3.347c0.605,1.359,0.456,3.75,0.337,5.673 c-0.018,0.29-0.036,0.573-0.051,0.847c0.031,0.03,0.275,0.266,0.833,0.266c0.406,0,0.874-0.122,1.392-0.364 c0.09-0.042,0.196-0.063,0.316-0.063c0.433,0,0.971,0.291,1.049,0.707c0.108,0.574-0.737,0.988-1.241,1.186 c-0.103,0.04-0.234,0.082-0.371,0.126c-0.558,0.179-1.399,0.447-1.657,1.058c-0.137,0.323-0.094,0.718,0.131,1.174 c0.004,0.009,0.008,0.017,0.012,0.026c0.068,0.149,1.736,3.975,5.467,4.589c0.137,0.025,0.235,0.145,0.227,0.283 c-0.003,0.055-0.016,0.11-0.04,0.165c-0.169,0.386-0.902,0.93-3.464,1.331c-0.218,0.034-0.224,0.267-0.367,0.267 c-0.142,0-0.319-0.039-0.526-0.084 c-0.33-0.072-0.796-0.175-1.386-0.175c-0.327,0-0.667,0.04-1.012,0.118c-0.393,0.089-0.84,0.388-1.317,0.705 C28.045,34.91,26.451,36,24,36z"></path>
  </svg>
)


const getCountryFlag = (countryName) => {
  const country = countryOptions.find((c) => c.name === countryName)
  return country ? country.flag : null
}

/* =========================
 * Helpers
 * ========================= */
const isFiniteNumber = (v) => Number.isFinite(Number(v));
const n0 = (v) => (isFiniteNumber(v) ? Number(v) : 0);

const moneyAbs = (v) =>
  new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Math.abs(n0(v)));

const signedMoney = (v, sign = "auto", zeroSign = "+") => {
  const val = n0(v);
  const cleaned = Object.is(val, -0) ? 0 : val;

  if (cleaned === 0) {
    if (zeroSign === "+") return `+${moneyAbs(0)}`;
    if (zeroSign === "-") return `-${moneyAbs(0)}`;
    return moneyAbs(0);
  }

  if (sign === "+") return `+${moneyAbs(cleaned)}`;
  if (sign === "-") return `-${moneyAbs(cleaned)}`;

  return cleaned > 0 ? `+${moneyAbs(cleaned)}` : `-${moneyAbs(cleaned)}`;
};

const cap = (s) => {
  const str = String(s || "");
  return str ? str.charAt(0).toUpperCase() + str.slice(1) : "";
};

const recordsLabel = (count) => `${n0(count)} record(s)`;

function get(obj, path, fallback = undefined) {
  try {
    const parts = String(path).split(".");
    let cur = obj;
    for (const p of parts) {
      if (cur == null) return fallback;
      cur = cur[p];
    }
    return cur == null ? fallback : cur;
  } catch {
    return fallback;
  }
}

function flagFromCountryCode(code) {
  const cc = String(code || "").toUpperCase();
  if (!/^[A-Z]{2}$/.test(cc)) return "🌍";
  const A = 0x1f1e6;
  const base = "A".charCodeAt(0);
  return String.fromCodePoint(
    A + (cc.charCodeAt(0) - base),
    A + (cc.charCodeAt(1) - base)
  );
}

/* =========================
 * Platform meta (icons + label)
 * (your provided function, embedded)
 * ========================= */
export function getPlatformMeta(platform, className = "w-4 h-4") {
  const p = String(platform || "").toLowerCase();

  switch (p) {
    case "facebook":
    case "meta":
      return {
        name: "Meta",
        icon: <MetaIcon />,
      };

    case "google":
      return {
        name: "Google",
        icon: <GoogleIcon />,
      };

    case "tiktok":
      return {
        name: "TikTok",
        icon: <TikTokIcon />,
      };

    case "snapchat":
      return {
        name: "Snapchat",
        icon: <SnapchatIcon />,
      };

    default:
      return { name: platform || "Unknown", icon: <Tag size={16} /> };
  }
}

/* =========================
 * Main
 * ========================= */
export default function FinancialStats() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const [dateRange, setDateRange] = useState({ start: "", end: "" });
  const [perfTab, setPerfTab] = useState("clients"); // "clients" | "team"

  const [data, setData] = useState({
    overall: { kpisRow1: {}, kpisRow2: {} },
    timeSeries: [],
    byPlatform: [],
    clientsByCountry: [],
    teamPerformance: [],
    clientsPerformance: [],
  });

  const hasDateFilter = Boolean(dateRange.start || dateRange.end);
  const groupBy = "month";

  const fetchStats = async () => {
    try {
      setLoading(true);
      setError("");

      const body = {
        dateRange: hasDateFilter ? { ...dateRange } : null,
        groupBy,
      };

      const res = await statistiquesService.financialStats(body);
      const payload = res.data?.data || res.data || {};

      setData({
        overall: payload.overall || { kpisRow1: {}, kpisRow2: {} },
        timeSeries: Array.isArray(payload.timeSeries) ? payload.timeSeries : [],
        byPlatform: Array.isArray(payload.byPlatform) ? payload.byPlatform : [],
        clientsByCountry: Array.isArray(payload.clientsByCountry)
          ? payload.clientsByCountry
          : Array.isArray(payload.byCountry)
            ? payload.byCountry
            : [],
        teamPerformance: Array.isArray(payload.teamPerformance) ? payload.teamPerformance : [],
        clientsPerformance: Array.isArray(payload.clientsPerformance) ? payload.clientsPerformance : [],
      });
    } catch (err) {
      console.error("FinancialStats error:", err);
      setError(
        err?.response?.data?.message || err.message || "Failed to load financial stats."
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStats();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /* =========================
   * KPI normalization (robust)
   * ========================= */
  const k1 = data.overall?.kpisRow1 || {};
  const k2 = data.overall?.kpisRow2 || {};

  // Main KPIs
  const depositsTotal = n0(get(k1, "totalPayments.total", 0));
  const depositsCount = n0(get(k1, "totalPayments.count", 0));

  const posTracking = n0(get(k1, "positiveTrackingBalance", 0));
  const negTracking = n0(get(k1, "negativeTrackingBalance", 0));

  const topUpsTotal = n0(get(k2, "totalTopUps.total", 0));
  const topUpsCount = n0(get(k2, "totalTopUps.count", 0));

  const withdrawalsTotal =
    n0(get(k2, "totalTopDowns.total", 0)) || n0(get(k2, "totalWithdrawals.total", 0));
  const withdrawalsCount =
    n0(get(k2, "totalTopDowns.count", 0)) || n0(get(k2, "totalWithdrawals.count", 0));

  const refundsTotal = n0(get(k2, "totalRefunds.total", 0));
  const refundsCount = n0(get(k2, "totalRefunds.count", 0));

  // Activity KPIs (best-effort wiring)
  const topUpFeesTotal =
    n0(get(k2, "totalTopUpFees.total")) ||
    n0(get(k2, "topUpFees.total")) ||
    n0(get(k1, "topUpFees.total")) ||
    0;
  const topUpFeesCount =
    n0(get(k2, "totalTopUpFees.count")) ||
    n0(get(k2, "topUpFees.count")) ||
    n0(get(k1, "topUpFees.count")) ||
    0;

  const withdrawalFeesTotal =
    n0(get(k2, "totalWithdrawalFees.total")) ||
    n0(get(k2, "withdrawalFees.total")) ||
    n0(get(k1, "withdrawalFees.total")) ||
    0;
  const withdrawalFeesCount =
    n0(get(k2, "totalWithdrawalFees.count")) ||
    n0(get(k2, "withdrawalFees.count")) ||
    n0(get(k1, "withdrawalFees.count")) ||
    0;

  const providerFeesTotal = n0(get(k1, "providerFees.total", 0));
  const providerFeesCount = n0(get(k1, "providerFees.count", 0));

  const earnedFeesTotal =
    n0(get(k1, "earnedFees.total")) ||
    n0(get(k1, "netProfitNoFees.total")) ||
    n0(get(k1, "netProfit.total")) ||
    0;
  const earnedFeesCount =
    n0(get(k1, "earnedFees.count")) ||
    n0(get(k1, "netProfitNoFees.count")) ||
    n0(get(k1, "netProfit.count")) ||
    0;

  const assetsOutTotal =
    n0(get(k2, "totalAssetsInOut.debit.total")) ||
    n0(get(k2, "totalAssetsInOut.out.total")) ||
    n0(get(k2, "totalAssetsOut.total")) ||
    0;
  const assetsOutCount =
    n0(get(k2, "totalAssetsInOut.debit.count")) ||
    n0(get(k2, "totalAssetsInOut.out.count")) ||
    n0(get(k2, "totalAssetsOut.count")) ||
    0;

  const assetsInTotal =
    n0(get(k2, "totalAssetsInOut.credit.total")) ||
    n0(get(k2, "totalAssetsInOut.in.total")) ||
    n0(get(k2, "totalAssetsIn.total")) ||
    0;
  const assetsInCount =
    n0(get(k2, "totalAssetsInOut.credit.count")) ||
    n0(get(k2, "totalAssetsInOut.in.count")) ||
    n0(get(k2, "totalAssetsIn.count")) ||
    0;

  /* =========================
   * Charts data
   * ========================= */
  const ts = useMemo(
    () => (Array.isArray(data.timeSeries) ? data.timeSeries : []),
    [data.timeSeries]
  );

  const chartTopUpsVsWithdrawals = useMemo(() => {
    return ts.map((x) => ({
      label: x.date,
      topUps: n0(get(x, "topUps.total", 0)),
      withdrawals: n0(get(x, "topDowns.total", 0)),
    }));
  }, [ts]);

  const chartDepositsVsRefunds = useMemo(() => {
    return ts.map((x) => ({
      label: x.date,
      deposits: n0(get(x, "payments.total", 0)),
      refunds: n0(get(x, "refunds.total", 0)),
    }));
  }, [ts]);

  const platformDist = useMemo(() => {
    const rows = Array.isArray(data.byPlatform) ? data.byPlatform : [];
    const total = rows.reduce((s, r) => s + n0(r.amount), 0) || 0;

    return rows
      .map((r) => {
        const key = String(r.key || r.platform || "other").toLowerCase();
        const amount = n0(r.amount);
        const percent = isFiniteNumber(r.percent)
          ? n0(r.percent)
          : total > 0
            ? (amount / total) * 100
            : 0;

        return {
          key,
          label: getPlatformMeta(key).name || cap(key),
          value: amount,
          percent,
          count: n0(r.count),
          color: r.color || PLATFORM_COLORS[key] || PLATFORM_COLORS.other,
        };
      })
      .sort((a, b) => b.value - a.value);
  }, [data.byPlatform]);

  const clientsByCountry = useMemo(() => {
    const rows = Array.isArray(data.clientsByCountry) ? data.clientsByCountry : [];
    const total =
      rows.reduce((s, r) => s + n0(r.count ?? r.value ?? r.total), 0) || 0;

    return rows
      .map((r) => {
        const name = r.country || r.name || r.label || "Unknown";
        const code = r.countryCode || r.code || r.iso2 || r.iso || "";
        const count = n0(r.count ?? r.value ?? r.total);
        const percent = isFiniteNumber(r.percent)
          ? n0(r.percent)
          : total > 0
            ? (count / total) * 100
            : 0;
        return { name, code, count, percent };
      })
      .sort((a, b) => b.count - a.count);
  }, [data.clientsByCountry]);

  /* =========================
   * Actions
   * ========================= */
  const clearFilters = () => setDateRange({ start: "", end: "" });
  const resetAndRefresh = () => {
    clearFilters();
    setTimeout(fetchStats, 0);
  };
  const applyFilters = () => fetchStats();

  /* =========================
   * Render (layout unchanged)
   * ========================= */
  return (
    <div className="mx-auto text-start p-3 lg:p-7 space-y-6">
      {/* Header / Filters */}
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex flex-wrap items-center gap-3">
          <DateRangePicker
            onRangeChange={(r) => setDateRange(r)}
            value={dateRange}
            className={
              hasDateFilter
                ? "border-blue-500 bg-blue-50 text-blue-700 dark:border-blue-600 dark:bg-blue-900/20 dark:text-blue-300"
                : ""
            }
          />

          {hasDateFilter && (
            <button
              className="h-10 px-4 rounded-xl bg-neutral-900 text-white dark:bg-neutral-100 dark:text-neutral-900 text-sm flex items-center gap-2"
              onClick={applyFilters}
              disabled={loading}
            >
              {loading ? (
                <SpinnerGap size={16} className="animate-spin" />
              ) : (
                <CalendarBlank size={16} />
              )}
              Apply
            </button>
          )}

          <button
            className="h-10 px-4 rounded-xl border border-neutral-100 dark:border-neutral-900 bg-white dark:bg-neutral-950 text-sm text-neutral-700 dark:text-neutral-200 flex items-center gap-2 hover:bg-neutral-50 dark:hover:bg-neutral-900 "
            onClick={resetAndRefresh}
            disabled={loading}
          >
            <ArrowClockwise size={14} />
            Reset
          </button>
        </div>
      </div>

      {/* Error */}
      {error && (
        <div className="rounded-xl bg-red-50 dark:bg-red-950/40 text-red-700 dark:text-red-200 px-4 py-3 text-sm flex items-start gap-3 ">
          <TrendUp size={14} className="mt-0.5" />
          <div className="flex-1">
            <p className="font-medium">Couldn&apos;t load stats</p>
            <p className="text-[12px] mt-0.5">{error}</p>
          </div>
          <button
            onClick={fetchStats}
            className="ml-2 text-[12px] underline underline-offset-2 decoration-red-400 hover:text-red-900 dark:hover:text-red-100"
          >
            Retry
          </button>
        </div>
      )}

      {/* ========================= MAIN KPIs ========================= */}
      <SectionTitle title="→ Main KPIs" subtitle="Deposits, Tracking Balances, Top-Ups & Withdrawals" />

      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-6 gap-3">
        {loading ? (
          Array.from({ length: 6 }).map((_, i) => <KpiCardSkeleton key={i} />)
        ) : (
          <>
            <KpiCard
              title="Total Payments (Transfers)"
              icon={<ArrowUpRight size={16} />}
              value={moneyAbs(depositsTotal)}
              hint={recordsLabel(depositsCount)}
              tone="black"
            />

            <KpiCard
              title="Total Positive Tracking Balance"
              icon={<Wallet size={16} />}
              value={signedMoney(posTracking, "+", "+")}
              hint="Sum of all positive balances"
              tone="green"
            />

            <KpiCard
              title="Total Negative Tracking Balance"
              icon={<Wallet size={16} />}
              value={signedMoney(negTracking, "-", "-")}
              hint="Sum of all negative balances"
              tone="red"
            />

            <KpiCard
              title="Total Top-Ups"
              icon={<ArrowUpRight size={16} />}
              value={signedMoney(topUpsTotal, "+", "+")}
              hint={recordsLabel(topUpsCount)}
              tone="green"
            />

            <KpiCard
              title="Total Withdrawals"
              icon={<ArrowDownRight size={16} />}
              value={signedMoney(withdrawalsTotal, "-", "-")}
              hint={recordsLabel(withdrawalsCount)}
              tone="orange"
            />

            <KpiCard
              title="Total Refunds"
              icon={<ArrowDownRight size={16} />}
              value={signedMoney(refundsTotal, "-", "-")}
              hint={recordsLabel(refundsCount)}
              tone="red"
            />
          </>
        )}
      </div>

      {/* ========================= ACTIVITY KPIs ========================= */}
      <SectionTitle title="→ Activity KPIs" subtitle="Fees & Asset Movements (In / Out)" />

      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-6 gap-3">
        {loading ? (
          Array.from({ length: 6 }).map((_, i) => <KpiCardSkeleton key={i} />)
        ) : (
          <>
            <KpiCard
              title="Total Top-Up Fees"
              icon={<ArrowDownRight size={16} />}
              value={signedMoney(topUpFeesTotal, "auto", "+")}
              hint={recordsLabel(topUpFeesCount)}
              tone="yellow"
            />

            <KpiCard
              title="Total Withdrawal Fees"
              icon={<ArrowDownRight size={16} />}
              value={signedMoney(withdrawalFeesTotal, "-", "-")}
              hint={recordsLabel(withdrawalFeesCount)}
              tone="orange"
            />

            <KpiCard
              title="Total Providers Fees"
              icon={<ArrowDownRight size={16} />}
              value={signedMoney(providerFeesTotal, "-", "-")}
              hint={recordsLabel(providerFeesCount)}
              tone="red"
            />

            <KpiCard
              title="Total Earned Fees"
              icon={<TrendUp size={16} />}
              value={signedMoney(earnedFeesTotal, "auto", "+")}
              hint={recordsLabel(earnedFeesCount)}
              tone="green"
            />

            <KpiCard
              title="Total Assets (Out)"
              icon={<Wallet size={16} />}
              value={signedMoney(assetsOutTotal, "-", "-")}
              hint={recordsLabel(assetsOutCount)}
              tone="red"
            />

            <KpiCard
              title="Total Assets (In)"
              icon={<Wallet size={16} />}
              value={signedMoney(assetsInTotal, "+", "+")}
              hint={recordsLabel(assetsInCount)}
              tone="green"
            />
          </>
        )}
      </div>
      {/* ========================= TABLE (tabs) ========================= */}
      <div className="grid lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2">
          <Card>
            <div className="px-4 pt-4 pb-2 flex items-start justify-between gap-3 border-b border-neutral-100 dark:border-neutral-800/60">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-full bg-neutral-50 dark:bg-neutral-900 flex items-center justify-center text-neutral-500 dark:text-neutral-300">
                  <Users size={16} />
                </div>
                <div className="min-w-0">
                  <div className="text-base font-[400] text-neutral-900 dark:text-neutral-50 truncate">
                    Performance
                  </div>
                  <div className="text-sm text-neutral-500 dark:text-neutral-400 truncate">
                    Switch between Clients and Team performance
                  </div>
                </div>
              </div>

              <Tabs
                value={perfTab}
                onChange={setPerfTab}
                tabs={[
                  { value: "clients", label: "Clients performance" },
                  { value: "team", label: "Team performance" },
                ]}
              />
            </div>

            {loading ? (
              <div className="p-4">
                <Skeleton height="h-72" />
              </div>
            ) : perfTab === "clients" ? (
              data.clientsPerformance?.length ? (
                <PerfTable rows={data.clientsPerformance} type="client" />
              ) : (
                <EmptyState label="No client data for this period." />
              )
            ) : data.teamPerformance?.length ? (
              <PerfTable rows={data.teamPerformance} type="admin" />
            ) : (
              <EmptyState label="No team data for this period." />
            )}
          </Card>
        </div>
        <div className="lg:col-span-1 h-full">
          <Card>
            <CardHeader
              title="Clients by Location"
              subtitle="Weberz Clients Distribution"
              icon={<Users size={16} />}
            />
            {loading ? (
              <Skeleton height="h-72" />
            ) : clientsByCountry.length ? (
              <ClientsByCountry rows={clientsByCountry} />
            ) : (
              <EmptyState label="No country data for this period." />
            )}
          </Card>
        </div>


      </div>
      {/* ========================= CHARTS ========================= */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-3">

        <Card>
          <CardHeader
            title="Payments (Transfers) vs Refunds"
            subtitle="Monthly evolution"
            icon={<ChartBar size={16} />}
          />
          {loading ? (
            <Skeleton height="h-72" />
          ) : chartDepositsVsRefunds.length ? (
            <DualAreaChartModern
              data={chartDepositsVsRefunds}
              leftKey="deposits"
              rightKey="refunds"
              leftName="Deposits"
              rightName="Refunds"
              leftColor="#0ea5e9"
              rightColor="#ef4444"
            />
          ) : (
            <EmptyState label="No chart data for this period." />
          )}
        </Card>


        {/* right column stacked like your screenshots */}
        <div className="space-y-3">
          <Card>
            <CardHeader
              title="Platform distribution"
              subtitle="Revenue by advertising platform"
              icon={<GlobeHemisphereWest size={16} />}
            />
            {loading ? (
              <Skeleton height="h-72" />
            ) : platformDist.length ? (
              <PlatformDistributionECharts rows={platformDist} />
            ) : (
              <EmptyState label="No platform data for this period." />
            )}
          </Card>
        </div>
        <Card>
          <CardHeader
            title="Top-Ups vs Withdrawals"
            subtitle="Monthly evolution"
            icon={<ChartBar size={16} />}
          />
          {loading ? (
            <Skeleton height="h-72" />
          ) : chartTopUpsVsWithdrawals.length ? (
            <DualAreaChartModern
              data={chartTopUpsVsWithdrawals}
              leftKey="topUps"
              rightKey="withdrawals"
              leftName="Top-Ups"
              rightName="Withdrawals"
              leftColor="#22c55e"
              rightColor="#f59e0b"
            />
          ) : (
            <EmptyState label="No chart data for this period." />
          )}
        </Card>

      </div>


    </div>
  );
}

/* =========================
 * Components
 * ========================= */

function SectionTitle({ title, subtitle }) {
  return (
    <div className="space-y-1">
      <div className="text-lg font-[400] text-neutral-900 dark:text-neutral-50">
        {title}
      </div>
      {subtitle ? (
        <div className="text-sm text-neutral-500 dark:text-neutral-400">
          {subtitle}
        </div>
      ) : null}
    </div>
  );
}

function Card({ children, className = "" }) {
  return (
    <div
      className={`rounded-2xl border border-neutral-100 dark:border-neutral-900 h-full bg-white dark:bg-neutral-950  ${className}`}
    >
      {children}
    </div>
  );
}

function CardHeader({ title, subtitle, icon }) {
  return (
    <div className="px-4 py-3 border-b border-neutral-100 dark:border-neutral-800/60 flex items-center gap-2">
      <div className="w-8 h-8 rounded-full bg-neutral-50 dark:bg-neutral-900 flex items-center justify-center text-neutral-500 dark:text-neutral-300">
        {icon}
      </div>
      <div className="min-w-0">
        <div className="text-base font-[400] text-neutral-900 dark:text-neutral-50 truncate">
          {title}
        </div>
        <div className="text-sm text-neutral-500 dark:text-neutral-400 truncate">
          {subtitle}
        </div>
      </div>
    </div>
  );
}

function KpiCard({ title, icon, value, hint, tone = "black" }) {
  const toneClass =
    tone === "green"
      ? "text-emerald-600 dark:text-emerald-500"
      : tone === "orange"
        ? "text-orange-500 dark:text-orange-500"
        : tone === "red"
          ? "text-red-600 dark:text-red-500"
          : tone === "yellow"
            ? "text-yellow-500 dark:text-yellow-400"
            : tone === "blue"
              ? "text-sky-600 dark:text-sky-500"
              : "text-neutral-900 dark:text-neutral-50";

  return (
    <div className="rounded-2xl border border-neutral-100 dark:border-neutral-900 bg-white dark:bg-neutral-950  px-4 py-3">
      <div className="flex items-center justify-between mb-2 gap-2">
        <div className="text-xs truncate font-medium text-neutral-500 dark:text-neutral-400">
          {title}
        </div>
        <div className="w-8 h-8 shrink-0 rounded-full bg-neutral-50 dark:bg-neutral-900 flex items-center justify-center text-neutral-500 dark:text-neutral-300">
          {icon}
        </div>
      </div>

      <div className={`text-2xl font-[400] ${toneClass}`}>{value}</div>

      <div className="mt-3 text-[11px] text-neutral-500 dark:text-neutral-400">
        {hint}
      </div>
    </div>
  );
}

function Tabs({ value, onChange, tabs }) {
  return (
    <div className="inline-flex rounded-xl bg-white dark:bg-neutral-950 p-1 ">
      {tabs.map((t) => {
        const active = t.value === value;
        return (
          <button
            key={t.value}
            type="button"
            onClick={() => onChange(t.value)}
            className={[
              "px-3 h-8 rounded-lg text-xs font-medium transition-colors",
              active
                ? "bg-neutral-900 text-white dark:bg-neutral-100 dark:text-neutral-900"
                : "text-neutral-700 dark:text-neutral-200 hover:bg-neutral-50 dark:hover:bg-neutral-900",
            ].join(" ")}
          >
            {t.label}
          </button>
        );
      })}
    </div>
  );
}

function Skeleton({ height = "h-64" }) {
  return (
    <div
      className={`${height} w-full bg-neutral-100 dark:bg-neutral-900 relative overflow-hidden rounded-2xl`}
    >
      <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/40 dark:via-neutral-700/30 to-transparent animate-[shimmer_1.4s_infinite]" />
      <style>{`@keyframes shimmer { 100% { transform: translateX(100%); } }`}</style>
    </div>
  );
}

function ShimmerBar({ className = "" }) {
  return (
    <div className={`relative overflow-hidden rounded-lg bg-neutral-100 dark:bg-neutral-800 ${className}`}>
      <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/40 dark:via-neutral-700/30 to-transparent animate-[shimmer_1.4s_infinite]" />
    </div>
  );
}

function KpiCardSkeleton() {
  return (
    <div className="rounded-2xl border border-neutral-100 dark:border-neutral-900 bg-white dark:bg-neutral-950 px-4 py-3">
      <div className="flex items-center justify-between mb-3 gap-2">
        <ShimmerBar className="h-3 w-28" />
        <div className="w-8 h-8 shrink-0 rounded-full bg-neutral-100 dark:bg-neutral-800 relative overflow-hidden">
          <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/40 dark:via-neutral-700/30 to-transparent animate-[shimmer_1.4s_infinite]" />
        </div>
      </div>
      <ShimmerBar className="h-7 w-36 mb-4" />
      <ShimmerBar className="h-2.5 w-20" />
    </div>
  );
}

function EmptyState({ label = "No data for this section." }) {
  return (
    <div className="h-72 flex items-center justify-center text-xs text-neutral-500 dark:text-neutral-400">
      {label}
    </div>
  );
}

/* =========================
 * Area charts (Recharts)
 * ========================= */
function DualAreaChartModern({
  data,
  leftKey,
  rightKey,
  leftName,
  rightName,
  leftColor,
  rightColor,
}) {
const [isDark, setIsDark] = useState(
    typeof document !== "undefined" &&
    document.documentElement.classList.contains("dark")
  );

  useEffect(() => {
    const observer = new MutationObserver(() => {
      setIsDark(document.documentElement.classList.contains("dark"));
    });
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ["class"] });
    return () => observer.disconnect();
  }, []);  const grid = isDark ? "rgba(255,255,255,0.06)" : "rgba(0,0,0,0.06)";
  const text = isDark ? "#e5e7eb" : "#111827";
  const sub = isDark ? "#9ca3af" : "#6b7280";

  return (
    <div className="h-72 px-3 py-3 ">
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={data} margin={{ top: 10, right: 14, left: 0, bottom: 0 }}>
          <defs>
            <linearGradient id={`g_${leftKey}`} x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor={leftColor} stopOpacity={0.35} />
              <stop offset="95%" stopColor={leftColor} stopOpacity={0.02} />
            </linearGradient>
            <linearGradient id={`g_${rightKey}`} x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor={rightColor} stopOpacity={0.35} />
              <stop offset="95%" stopColor={rightColor} stopOpacity={0.02} />
            </linearGradient>
          </defs>

          <CartesianGrid stroke={grid} vertical={false} />
          <XAxis
            dataKey="label"
            tick={{ fill: sub, fontSize: 11 }}
            axisLine={{ stroke: grid }}
            tickLine={{ stroke: grid }}
          />
          <YAxis
            tick={{ fill: sub, fontSize: 11 }}
            axisLine={{ stroke: grid }}
            tickLine={{ stroke: grid }}
            tickFormatter={(v) => Number(v || 0).toLocaleString()}
          />

          <Tooltip
            contentStyle={{
              background: isDark ? "#0b1220" : "#111827",
              border: "none",
              borderRadius: 14,
              color: "#e5e7eb",
              fontSize: 12,
            }}
            labelStyle={{ color: text }}
            formatter={(val, name) => [Number(val || 0).toLocaleString(), name]}
          />

          <Area
            type="monotone"
            dataKey={leftKey}
            name={leftName}
            stroke={leftColor}
            strokeWidth={2.4}
            fill={`url(#g_${leftKey})`}
          />
          <Area
            type="monotone"
            dataKey={rightKey}
            name={rightName}
            stroke={rightColor}
            strokeWidth={2.4}
            fill={`url(#g_${rightKey})`}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
// ✅ Drop-in replacement for your component
// - Uses ECharts donut (no built-in legend)
// - Custom legend (top-left) like screenshot (2 columns)
// - Right list with icons + separators + light percent
// - Proper slice gaps + rounded ends
// - Uses your getPlatformMeta(platform) + PLATFORM_COLORS


function PlatformDistributionECharts({ rows }) {
  const elRef = useRef(null);
  const chartRef = useRef(null);

  const [isDark, setIsDark] = useState(
    typeof document !== "undefined" &&
    document.documentElement.classList.contains("dark")
  );

  useEffect(() => {
    const observer = new MutationObserver(() => {
      setIsDark(document.documentElement.classList.contains("dark"));
    });
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"],
    });
    return () => observer.disconnect();
  }, []);

  const gapColor = isDark ? "#030712" : "#ffffff";

  const sorted = useMemo(() => {
    const arr = Array.isArray(rows) ? [...rows] : [];
    return arr.sort((a, b) => n0(b.value) - n0(a.value));
  }, [rows]);

  const seriesData = useMemo(() => {
    return sorted.map((r) => {
      const key = String(r.key || r.platform || r.label || "other").toLowerCase();
      return {
        name: getPlatformMeta(key)?.name || r.label || key,
        value: n0(r.value),
        itemStyle: {
          color: PLATFORM_COLORS[key] || r.color || PLATFORM_COLORS.other,
        },
      };
    });
  }, [sorted]);

  // Build option imperatively so it always uses latest isDark/gapColor
  const buildOption = useCallback(() => {
    return {
      backgroundColor: "transparent",
      tooltip: {
        trigger: "item",
        borderWidth: 0,
        padding: 10,
        backgroundColor: isDark ? "rgba(15,23,42,.95)" : "rgba(17,24,39,.95)",
        textStyle: { color: "#fff", fontSize: 12 },
        formatter: (p) => {
          const val = Number(p.value || 0).toLocaleString();
          const pct = Math.round(Number(p.percent || 0));
          return `${p.name}: ${pct}% • ${val}`;
        },
      },
      series: [
        {
          name: "Platform distribution",
          type: "pie",
          radius: ["58%", "96%"],
          center: ["50%", "56%"],
          startAngle: 90,
          clockwise: true,
          avoidLabelOverlap: true,
          label: { show: false },
          labelLine: { show: false },
          padAngle: 2,
          minAngle: 2,
          itemStyle: {
            borderColor: gapColor,
            borderWidth: 4,
            borderRadius: 10,
          },
          emphasis: { scale: true, scaleSize: 6 },
          data: seriesData,
        },
      ],
    };
  }, [isDark, gapColor, seriesData]);

  // Init chart once
  useEffect(() => {
    const dom = elRef.current;
    if (!dom) return;

    const chart = echarts.getInstanceByDom(dom) || echarts.init(dom, null, { renderer: "canvas" });
    chartRef.current = chart;

    const ro = typeof ResizeObserver !== "undefined"
      ? new ResizeObserver(() => chart.resize())
      : null;
    ro?.observe(dom);

    const onResize = () => chart.resize();
    window.addEventListener("resize", onResize);

    return () => {
      window.removeEventListener("resize", onResize);
      ro?.disconnect();
      chart.dispose();
      chartRef.current = null;
    };
  }, []);

  // Re-apply option whenever isDark or data changes
  useEffect(() => {
    const chart = chartRef.current;
    if (!chart) return;
    chart.setOption(buildOption(), true);
  }, [buildOption]);

  return (
    <div className="p-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
        <div className="h-64 w-full">
          <div ref={elRef} className="h-64 w-full" />
        </div>

        <div className="w-full">
          {sorted.map((r, idx) => {
            const key = String(r.key || r.platform || r.label || "other").toLowerCase();
            const meta = getPlatformMeta(key, "w-8 h-8");
            const isLast = idx === sorted.length - 1;

            return (
              <div
                key={key || idx}
                className={[
                  "flex items-center justify-between gap-2 py-1",
                  !isLast ? "border-b border-neutral-200/60 dark:border-neutral-800/60" : "",
                ].join(" ")}
              >
                <div className="flex items-center gap-4 min-w-0">
                  <div className="shrink-0">{meta?.icon}</div>
                  <div className="min-w-0">
                    <div className="text-sm font-[400] text-neutral-900 dark:text-neutral-50 truncate">
                      {meta?.name || r.label || key}
                    </div>
                  </div>
                </div>
                <div className="text-sm font-[400] text-neutral-400 tabular-nums">
                  {Math.round(n0(r.percent))}%
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
/* =========================
 * Clients by country (no region)
 * - removed borders
 * ========================= */
function ClientsByCountry({ rows }) {
  const top = rows.slice(0, 8);
  const max = top.reduce((m, r) => Math.max(m, n0(r.count)), 0) || 1;

  return (
    <div className="p-4">
      <div className="space-y-4">
        {top.map((r, idx) => (
          <div key={`${r.name}-${idx}`} className="flex items-center justify-between gap-3">
            <div className="flex items-center gap-3 min-w-0">
              <div className="w-9 h-9 rounded-xl bg-neutral-50 dark:bg-neutral-900/40 flex items-center justify-center text-base">
                {getCountryFlag(r.name) ? (
                  <img
                    src={getCountryFlag(r.name)}
                    className="h-2.5 w-4 object-cover"
                    alt={r.name}
                  />
                ) : null}
              </div>

              <div className="min-w-0">
                <div className="text-sm font-[400] text-neutral-900 dark:text-neutral-50 truncate">
                  {r.name}
                </div>
                <div className="mt-1 h-2 w-64 max-w-[60vw] rounded-full bg-neutral-100 dark:bg-neutral-900 overflow-hidden">
                  <div
                    className="h-full rounded-full bg-yellow-500"
                    style={{ width: `${(n0(r.count) / max) * 100}%` }}
                  />
                </div>
              </div>
            </div>

            <div className="text-right tabular-nums">
              <div className="text-sm font-[400] text-neutral-900 dark:text-neutral-50">
                {n0(r.count).toLocaleString()}
              </div>
              <div className="text-xs text-neutral-500 dark:text-neutral-400">
                {n0(r.percent).toFixed(1)}%
              </div>
            </div>
          </div>
        ))}

        {rows.length > top.length ? (
          <div className="pt-2 text-xs text-neutral-500 dark:text-neutral-400">
            Showing top {top.length}.
          </div>
        ) : null}
      </div>
    </div>
  );
}

/* =========================
 * Tables
 * ========================= */
function pickMetric(row, key) {
  const direct = row?.[key];
  if (direct && typeof direct === "object")
    return { total: n0(direct.total), count: n0(direct.count) };

  const m = row?.metrics?.[key];
  if (m && typeof m === "object") return { total: n0(m.total), count: n0(m.count) };

  // backward compat
  if (key === "providerFees")
    return {
      total: n0(row?.transfers?.providerFees),
      count: n0(row?.transfers?.count || row?.transfers?.transactions),
    };
  if (key === "netProfit")
    return {
      total: n0(row?.transfers?.profit),
      count: n0(row?.transfers?.count || row?.transfers?.transactions),
    };

  return { total: 0, count: 0 };
}

function PerfTable({ rows, type }) {
  const isAdmin = type === "admin";

  return (
    <div className="h-[420px] overflow-auto">
      <table className="min-w-[960px] w-full text-sm">
        <thead className="sticky top-0 bg-neutral-50 dark:bg-neutral-900 border-b border-neutral-100 dark:border-neutral-800/60 z-10">
          <tr>
            {isAdmin ? (
              <>
                <Th>Name</Th>
                <Th>Clients</Th>
                <Th>Deposits</Th>
                <Th>Top-Ups</Th>
                <Th>Withdrawals</Th>
                <Th>Provider Fees</Th>
                <Th>Weberz Fees</Th>
                <Th>Refunds</Th>
              </>
            ) : (
              <>
                <Th>Client Reference</Th>
                <Th>Deposits</Th>
                <Th>Top-Ups</Th>
                <Th>Withdrawals</Th>
                <Th>Provider Fees</Th>
                <Th>Weberz Fees</Th>
                <Th>Refunds</Th>
              </>
            )}
          </tr>
        </thead>

        <tbody className="divide-y divide-neutral-100 dark:divide-neutral-800 bg-white dark:bg-neutral-950">
          {rows.map((r, idx) => {
            const deposits     = pickMetric(r, "deposits");
            const refunds      = pickMetric(r, "refunds");
            const topUps       = pickMetric(r, "topUps");
            const topDowns     = pickMetric(r, "topDowns");
            const providerFees = pickMetric(r, "providerFees");
            const weberzFees   = pickMetric(r, "netProfit"); // netProfit = Weberz Fees

            return (
              <tr
                key={r.id || r._id || idx}
                className="hover:bg-neutral-50 dark:hover:bg-neutral-900 transition-colors"
              >
                {isAdmin ? (
                  <>
                    <Td strong>{r.name || "Unknown"}</Td>
                    <Td>{n0(r.clients)} record(s)</Td>
                  </>
                ) : (
                  <Td strong>{r.reference || r.name || "Unknown"}</Td>
                )}

                <MetricCell value={deposits.total}     count={deposits.count}     sign="+"    tone="green"  />
                <MetricCell value={topUps.total}       count={topUps.count}       sign="+"    tone="green"  />
                <MetricCell value={topDowns.total}     count={topDowns.count}     sign="-"    tone="orange" />
                <MetricCell value={providerFees.total} count={providerFees.count} sign="-"    tone="red"    />
                <MetricCell value={weberzFees.total}   count={weberzFees.count}   sign="auto" tone="blue"   />
                <MetricCell value={refunds.total}      count={refunds.count}      sign="-"    tone="red"    />
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

function MetricCell({ value, count, sign, tone }) {
  const toneClass =
    tone === "green"
      ? "text-emerald-600 dark:text-emerald-500"
      : tone === "orange"
        ? "text-orange-500 dark:text-orange-500"
        : tone === "blue"
          ? "text-sky-600 dark:text-sky-500"
          : tone === "red"
            ? "text-red-600 dark:text-red-500"
            : "text-neutral-900 dark:text-neutral-50";

  const zeroSign = sign === "-" ? "-" : "+";

  return (
    <td className="px-4 py-3 align-top">
      <div className={`text-[13px] font-[500] ${toneClass}`}>
        {signedMoney(value, sign, zeroSign)}
      </div>
      <div className="text-[11px] text-neutral-500 dark:text-neutral-400">
        {recordsLabel(count)}
      </div>
    </td>
  );
}

function Th({ children }) {
  return (
    <th className="px-4 py-2 text-xs font-[400] tracking-wide text-neutral-500 dark:text-neutral-400 uppercase text-left">
      {children}
    </th>
  );
}

function Td({ children, strong, className = "" }) {
  return (
    <td className={`px-4 py-3 text-[13px] text-neutral-700 dark:text-neutral-200 ${className}`}>
      {strong ? (
        <span className="font-medium text-neutral-900 dark:text-neutral-50">
          {children}
        </span>
      ) : (
        children
      )}
    </td>
  );
}
